import { render, staticRenderFns } from "./ModalGetPoint.vue?vue&type=template&id=2c44b27e&scoped=true&"
import script from "./ModalGetPoint.vue?vue&type=script&lang=js&"
export * from "./ModalGetPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44b27e",
  null
  
)

export default component.exports